var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 32 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 3.992A3.99 3.99 0 0 1 3.992 0h23.951a3.99 3.99 0 0 1 3.992 3.992v15.967a3.99 3.99 0 0 1-3.992 3.992H3.992A3.99 3.99 0 0 1 0 19.96zm3.992-1.996a1.996 1.996 0 0 0-1.996 1.996v1.996h27.943V3.992a1.996 1.996 0 0 0-1.996-1.996zM29.939 9.98H1.996v9.98a1.996 1.996 0 0 0 1.996 1.995h23.951a1.996 1.996 0 0 0 1.996-1.996z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.992 15.967a1.996 1.996 0 0 1 1.996-1.996h1.996a1.996 1.996 0 0 1 1.995 1.996v1.996a1.996 1.996 0 0 1-1.995 1.996H5.988a1.996 1.996 0 0 1-1.996-1.996z"
  })));
};
export default SvgCreditCard;